import fetchServer from "../fetchServer";

export default async function assignTeamToAgent(payload, setLoading) {
  let result = { return: 0, msg: "Something went wrong updating profile!" };
  setLoading?.(true);

  await fetchServer({
    method: "POST",
    url: "/main/v1/adminTeam/assignAgent?populate=accountManager",
    data: payload,
  })
    .then((res) => {
      if (res?.data && !res?.data?.error) {
        result = { return: 1, msg: "Successfull", data: res.data };
      } else result["msg"] = res?.data?.error || result["msg"];
    })
    .catch((err) => {
      console.log("Network Error!");
    })
    .finally(() => {
      setLoading?.(false);
    });

  return result;
}
